import axios from 'axios';
import authHeader from './auth-header';

const StatsService = {
  async getOverview() {
    try {
      const response = await axios.get('/admin/stats/overview', {
        headers: authHeader()
      });
      return response.data;
    } catch (error) {
      console.error("Failed to fetch stats overview:", error);
      throw error;
    }
  },

  async getTeacherDashboardStats() {
    try {
      const response = await axios.get('/teacher/dashboard/stats', {
        headers: authHeader(),
        params: {
          include_financial: true
        }
      });
      return response.data;
    } catch (error) {
      console.error("Failed to fetch teacher dashboard stats:", error);
      throw error;
    }
  }
};

export default StatsService;
